import { PrismicRichText, PrismicRichTextProps } from '@prismicio/react';

const renderSpan = ({ children, ...rest }: { children: React.ReactNode }) => (
  <span {...rest}>{children}</span>
);

const renderHyperlink = ({
  children,
  ...rest
}: {
  children: React.ReactNode;
}) => {
  return <span {...rest}>{children}</span>;
};

/**
 * PrismicRichText wrapper for inline elements
 */
const PrismicInlineText = ({ components, ...props }: PrismicRichTextProps) => {
  return (
    <PrismicRichText
      components={{
        paragraph: renderSpan,
        hyperlink: renderHyperlink,
        ...components
      }}
      {...props}
    />
  );
};

export default PrismicInlineText;
